<template>
  <div>
    <h3 class="filter-title">{{ $t('filters.title') }}
      <v-btn id="students-save-filter" flat small
             :title="$t('filters.clear_all')"
             :aria-label="$t('filters.clear_all')"
             v-if="filterClear" @click="filterClear"
             class="caption filter-actions-icon"
             :disabled="!filtersApplied">
        <v-icon small class="mr-1 hidden-lg-and-down">close</v-icon>
        <v-tooltip bottom>
          <v-icon medium slot="activator" class="mr-1 hidden-xl-only">close</v-icon>
          <span v-html="$t('filters.clear_all')"></span>
        </v-tooltip>
        <h4 class="filter-actions-text">{{ $t('filters.clear_all') }}</h4>
      </v-btn>
      <save-my-filter :fromStudents="fromStudents" :flagDisplaySaveFilter="flagDisplaySaveFilter"
                      :filtersApplied="filtersApplied"
                      :selected-filter-text="selectedButtonText"
                      :saved-filter-text="savedFilterText"/>
    </h3>

    <div v-for="(type, keyType) in filterTypes" v-if="!type.isNotTutor">
      <div v-if="isEngagement(type.header) && flagDisplayAverageEngagementRating" class="engagement-filters">
        <h4 v-if="type.listName === 'myFilterIds' && flagDisplaySaveFilter">{{ $t(type.header) }}</h4>
        <h4 v-if="type.listName !== 'myFilterIds'"
            :class="[isDailyEngagement(type.header) && !flagDisplaySaveFilter ? 'pt-3' : 'pt-2']">
          {{ $t(type.header) }}
        </h4>

        <v-layout v-if="type.isList && type.listName !== 'myFilterIds'" row wrap>
          <filter-list :filter-type="keyType" @filter:list-change="filterListChangeInner"
                       :source="listSources[type.listName]" :id="listFilterIds($t(type.header))"></filter-list>
        </v-layout>
        <v-layout v-else-if="type.isList && type.listName === 'myFilterIds' && flagDisplaySaveFilter" row wrap>
          <my-filter-list :filter-type="keyType" @filter:list-change="filterListChangeInner"
                          :source="listSources[type.listName]" :selected-filter-text="selectedFilterText"
                          :saved-filter-text="savedButtonText" :id="listFilterIds($t(type.header))" />
        </v-layout>
        <v-layout v-else row wrap>
          <filter-button v-for="(button, keyName) in type.values" :key="keyName"
                         :text="engagementButtonText(button.index)"
                         :filter-type="keyType" :filter-name="keyName"
                         :enabled="button.value"
                         @filter:click="filterChangeInner"
                         :icon="button.icon"
                         :disabled="disabled" :id="buttonFilterIds($t(type.header), keyName)"/>
        </v-layout>
      </div>

      <div v-else class="pt-2">
        <h4 v-if="type.listName === 'myFilterIds' && flagDisplaySaveFilter">{{ $t(type.header) }}</h4>
        <h4 v-if="type.listName !== 'myFilterIds' && type.listName !== 'myGroupIds' && type.header && type.header.length > 0">
          {{ $t(type.header) }}
        </h4>

        <v-layout v-if="type.isList && type.listName !== 'myFilterIds' && type.listName !== 'myGroupIds'" row wrap>
          <filter-list :filter-type="keyType" @filter:list-change="filterListChangeInner"
                       :source="listSources[type.listName]" :id="listFilterIds($t(type.header))"></filter-list>
        </v-layout>
        <v-layout v-else-if="type.isList && type.listName === 'myFilterIds' && flagDisplaySaveFilter" row wrap>
          <my-filter-list
            :filter-type="keyType"
            @filter:list-change="filterListChangeInner"
            :source="listSources[type.listName]"
            :selected-filter-text="selectedFilterText"
            :saved-filter-text="savedButtonText"
            :show-delete-option="showDeleteOption"
            :show-default-option="showDefaultOption"
            :id="listFilterIds($t(type.header))">
          </my-filter-list>
        </v-layout>
        <v-layout v-else-if="type.isList && type.listName === 'myGroupIds'" row wrap>
          <MyGroupsFilterList
            :filter-type="keyType"
            @filter:list-change="filterListChangeInner"
            :source="listSources[type.listName]"
            :selected-filter-text="selectedGroupFilterText"
            :saved-my-group-text="savedButtonText"
            :show-delete-option="showDeleteOption"
            :id="listFilterIds($t(type.header))">
          </MyGroupsFilterList>
        </v-layout>
        <v-layout v-else row wrap>
          <filter-button v-for="(button, keyName) in type.values" :key="keyName" :text="button.text"
                         :filter-type="keyType" :filter-name="keyName"
                         :enabled="button.value"
                         @filter:click="filterChangeInner"
                         :icon="button.icon"
                         :disabled="disabled" :id="buttonFilterIds($t(type.header), keyName)"
                         :class="fullWidth ? 'filter-button' : ''"
          />
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
  import FilterButton from './FilterButton'
  import FilterList from './FilterList'
  import MyFilterList from './MyFilterList'
  import SaveMyFilter from './SaveMyFilter'
  import { filtersApplied } from '../../HelperMethods'
  import { mapGetters, mapState } from 'vuex'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'
  import MyGroupsFilterList from './MyGroupsFilterList'
  import { RESET_ALL_FILTERS, SET_STUDENTS_LIST_FILTER_ARRAY } from '../../store/mutation-types'

  export default {
    components: {MyGroupsFilterList, FilterButton, FilterList, MyFilterList, SaveMyFilter},
    name: 'filter-component',
    data () {
      return {
        dialog: false,
        selectedButtonText: {},
        savedButtonText: ''
      }
    },
    props: {
      filterTypes: {
        type: Object,
        required: true
      },
      filterChange: {
        type: Function,
        required: true
      },
      filterListChange: {
        type: Function
      },
      filterClear: {
        type: Function
      },
      disabled: {
        type: Boolean,
        required: true
      },
      listSources: {
        type: Object
      },
      myFilterChange: {
        type: Function
      },
      from: {
        type: String
      },
      fullWidth: {
        type: Boolean
      }
    },
    methods: {
      filterChangeInner (filterObject) {
        this.$store.commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterType: 'myFilterIds', filterName: []})
        if (!this.disabled) {
          this.filterChange(filterObject)
        }
      },
      filterListChangeInner (filterObject) {
        // if my filters cleared
        if (filterObject.filterType === 'myFilterIds') {
          if (filterObject.filterName.length === 0) {
            this.filterClear(filterObject)
          } else {
            this.$store.commit(RESET_ALL_FILTERS)
            this.myFilterChange(filterObject)
          }
        } else {
          if (!this.disabled) {
            if (filterObject.filterType === 'myGroupIds') {
              this.$store.commit(RESET_ALL_FILTERS)
            }
            this.$store.commit(SET_STUDENTS_LIST_FILTER_ARRAY, {filterType: 'myFilterIds', filterName: []})
            this.filterListChange(filterObject)
          }
        }
      },
      selectedFilterText (filterObject) {
        this.selectedButtonText = filterObject
        return filterObject
      },
      selectedGroupFilterText (filterObject) {
        this.selectedButtonText = filterObject
        return filterObject
      },
      savedFilterText (savedText) {
        this.savedButtonText = savedText
        return savedText
      },
      isEngagement (identifier) {
        return identifier.toString().includes('average') || identifier.toString().includes('engagement')
      },
      isDailyEngagement (identifier) {
        return identifier.toString().includes('engagement')
      },
      buttonFilterIds (keyHeader, keyName) {
        return 'filter-button-' + keyHeader.toLowerCase() + '-' + keyName.toLowerCase()
      },
      listFilterIds (keyHeader) {
        return 'filter-list-' + keyHeader.toLowerCase()
      },
      engagementButtonText (index) {
        return this.ratingLabel[index]
      }
    },
    computed: {
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      ...mapState({
        showDefaultOption: state => state.students.showFilterDefaultOption,
        showDeleteOption: state => state.students.showFilterDeleteOption,
        moduleStudent: state => state.profile.module.student,
        functionMyStudent: state => state.students.functions.myStudents,
        optionEnableMyFilter: state => state.students.options.enable.myFilter,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement,
        ratingLabel: state => state.config.ratingLabel
      }),
      filtersApplied () {
        return filtersApplied(this.filterTypes)
      },
      fromStudents () {
        return this.from === 'students'
      },
      flagDisplaySaveFilter () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableMyFilter)
      },
      flagDisplayAverageEngagementRating () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      }
    }
  }
</script>

<style scoped>
  .filter-title {
    position: relative;
    margin: 20px 0;
  }

  #students-save-filter {
    position: absolute;
    top: -2px;
    right: 0;
    margin: 0;
  }

  #students-clear-filters {
    position: absolute;
    top: 30px;
    right: 0;
    margin: 0;
  }

  @media only screen and (max-width: 1904px) {
    .filter-actions-text {
      display: none;
    }

    .filter-actions-icon {
      min-width: 0;
    }
  }

  @media only screen and (min-width: 1904px) {
    .engagement-filters {
      width: 176px;
      float: left;
    }
  }

  @media (max-width: 600px) {
    .filter-actions-icon {
      right: -16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/FilterComponent.vue